<ion-header>
    <ion-toolbar>
        <ion-title>phone-login</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content> </ion-content>
